import { useState } from 'react';

// Simple toast implementation
let toastFunction = null;

export const useToast = () => {
  return {
    toast: (options) => {
      if (toastFunction) {
        toastFunction(options);
      } else {
        // Fallback to alert if toast not set up
        console.log('Toast:', options.title, options.description);
        if (options.variant === 'destructive') {
          alert(`Error: ${options.title}\n${options.description}`);
        } else {
          alert(`${options.title}\n${options.description}`);
        }
      }
    }
  };
};

export const setToastFunction = (fn) => {
  toastFunction = fn;
};